import "../style/FooterStyles.css"


/*create the footer, 2 section, top and bottom*/
/*"fa-brands fa-facebook-square" is icons */
const Footer = () => {
    return (
        <div className="footer">
            <div className="bottom">
                <div>
                    <h1>Queen's Nails</h1>
                    <p>Kaufman County</p>
                    <a href="https://www.facebook.com/QueenNailsKaufman/" target="_blank" className="top">
                        <i className="fa-brands fa-facebook"></i>
                    </a>
                    <a href="https://www.google.com/localservices/prolist?g2lbs=AAEPWCuEajvEyPnKB6L0E4ktu8Lyuy_fDCjWfVCANQKA7sXbPvdVvxSk2pzw4IIxTFFW5w_QkKk7T9fVUcsAODswcOniyGjMhQ%3D%3D&hl=en-US&gl=us&cs=1&ssta=1&q=queen%20nail%20kauman&oq=queen%20nail%20kauman&slp=MgBSAggCYAB6lgJDaEZ4ZFdWbGJpQnVZV2xzSUd0aGRXMWhia2pZaGUtOTVZQ0FnQWhhSHhBQUVBRVFBaGdBR0FFWUFpSVJjWFZsWlc0Z2JtRnBiQ0JyWVhWdFlXNlNBUXB1WVdsc1gzTmhiRzl1bWdFa1EyaGtSRk5WYUU1TlJ6bHVVekJXU2xFd1JtNVRWVTU0WW5wb2VGVkVaRzVTVWtGQ3FnRlJFQUVxRlNJUmNYVmxaVzRnYm1GcGJDQnJZWFZ0WVc0b0FESWZFQUVpRzdKZkFuMkhFUEdpQlBWellZN3pLWlUxVUEzRjd0Y2VqZXFQVkRJVkVBSWlFWEYxWldWdUlHNWhhV3dnYTJGMWJXRnU0QUVBLWdFRUNEMFFQUZIBKQoNL2cvMTFxcGwwbWdrdwoLL2cvMXRmc2h0ZzQKCy9nLzF0Y3dyanFz&src=2&spp=CgsvZy8xdGN3cmpxczrkAVdoOFFBQkFCRUFJWUFCZ0JHQUlpRVhGMVpXVnVJRzVoYVd3Z2EyRjFiV0Z1a2dFS2JtRnBiRjl6WVd4dmJwb0JKRU5vWkVSVFZXaE9UVWM1YmxNd1ZrcFJNRVp1VTFWT2VHSjZhSGhWUkdSdVVsSkJRcW9CVVJBQktoVWlFWEYxWldWdUlHNWhhV3dnYTJGMWJXRnVLQUF5SHhBQklodXlYd0o5aHhEeG9nVDFjMkdPOHltVk5WQU54ZTdYSG8zcWoxUXlGUkFDSWhGeGRXVmxiaUJ1WVdsc0lHdGhkVzFoYmc9PQ%3D%3D&serdesk=1&lrlstt=1747097779387&ved=2ahUKEwiEhrmynp-NAxV_4MkDHWWmATsQvS56BAgvEAE&scp=Cg9nY2lkOm5haWxfc2Fsb24SQRISCY_kETduY06GEdh7lRt5SA9GIhNBcmxpbmd0b24sIFRYIDc2MDE3KhQNjul0ExVtwQzGHd7yehMlNrAmxjABGhFxdWVlbiBuYWlsIGthdW1hbiIRcXVlZW4gbmFpbCBrYXVtYW4qCk5haWwgc2Fsb24%3D" target="_blank" className="top">
                        <i className="fa-brands fa-google"></i>
                    </a>
                </div>
                <div>
                    <h4>Business Hours</h4>
                    <a >Monday - Friday: 10 AM - 7 PM</a>
                    <a >Saturday: 9 AM - 6 PM</a>
                    <a >Sunday: Closed</a>
                </div>
                <div>
                    <h4>Contact</h4>
                    <a href="tel:+14693760101">
                        <i className="fa-solid fa-phone"></i> Phone: (469) 376-0101
                    </a>
                    <a href="https://www.google.com/maps/place/Queen+Nails/@32.5882501,-96.3030037,16z/data=!3m1!4b1!4m6!3m5!1s0x86494995d8a0d691:0x6ab418ce691f87d8!8m2!3d32.5882501!4d-96.3030037!16s%2Fg%2F1tcwrjqs?entry=ttu&g_ep=EgoyMDI1MDUwNy4wIKXMDSoASAFQAw%3D%3D" target="_blank">
                        <i className="fa-solid fa-location-dot"> </i>
                        102 S Old Rail Rd, Kaufman, TX 75142
                    </a>
                    <a href="mailto:queennailscs@gmail.com">
                        <i className="fa-solid fa-envelope"></i> queennailscs@gmail.com
                    </a>
                </div>
            </div>

            <div className="top">

            </div>
            <div className="copyright">
                <p>&copy; 2025 Queen's Nails. All rights reserved.</p>
            </div>


        </div>
    )
}

export default Footer;